module.exports = __webpack_public_path__ + "static/media/3.e5329796.jpeg";